function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Divider } from '@unite-us/ui';
import DraftEditorField from "../form/DraftEditorField";
import ExpandableContainer from "../ExpandableContainer";
import LabelTextInline from "../Shared/LabelTextInline";
import { FormattedMessage } from 'react-intl';
import stateEnums from "../utils/enums/stateEnums";
import ageRangeConverters from "../utils/ages/ageRangeConverters";
import { isEligTextEmpty } from "../utils/programs/checkEmptyText";
var ProgramEligibility = function ProgramEligibility(props) {
  var _requirements$filter;
  var className = props.className,
    _props$program = props.program,
    accessibility_options = _props$program.accessibility_options,
    delivery_options = _props$program.delivery_options,
    description = _props$program.description,
    eligibility_text = _props$program.eligibility_text,
    languages = _props$program.languages,
    payment_options = _props$program.payment_options,
    population_specializations = _props$program.population_specializations,
    population_restrictions = _props$program.population_restrictions,
    transportation_options = _props$program.transportation_options,
    age_requirements = _props$program.age_requirements,
    age_specializations = _props$program.age_specializations,
    requirements = _props$program.requirements,
    postal_code_requirements = _props$program.postal_code_requirements,
    state_requirements = _props$program.state_requirements,
    county_requirements = _props$program.county_requirements,
    city_requirements = _props$program.city_requirements,
    showLess = props.showLess,
    showMore = props.showMore;
  var processAgeText = ageRangeConverters.processAgeText,
    convertApiAgeRangeToUnits = ageRangeConverters.convertApiAgeRangeToUnits;
  var countyRequirments = county_requirements === null || county_requirements === void 0 ? void 0 : county_requirements.map(function (r) {
    return r.name.concat(', ', r.state);
  }).join('; ');
  var cityRequirements = city_requirements === null || city_requirements === void 0 ? void 0 : city_requirements.map(function (r) {
    return r.name.concat(', ', r.state);
  }).join('; ');
  var postalCodeRequirements = postal_code_requirements === null || postal_code_requirements === void 0 ? void 0 : postal_code_requirements.map(function (r) {
    return r.postal_code;
  });
  var transformedStateRequirements = state_requirements === null || state_requirements === void 0 ? void 0 : state_requirements.map(function (s) {
    return stateEnums.states[s.id];
  });
  var transformedAgeRequirements = age_requirements ? processAgeText.apply(void 0, _toConsumableArray(convertApiAgeRangeToUnits(age_requirements))) : null;
  var transformedAgeSpecializations = age_specializations ? processAgeText.apply(void 0, _toConsumableArray(convertApiAgeRangeToUnits(age_specializations))) : null;
  var genderRequirements = requirements === null || requirements === void 0 || (_requirements$filter = requirements.filter(function (r) {
    return r.category === 'gender';
  })) === null || _requirements$filter === void 0 ? void 0 : _requirements$filter.map(function (r) {
    return r.display_name;
  });
  var hasRegionalElig = Boolean([].concat(_toConsumableArray(postal_code_requirements || []), _toConsumableArray(state_requirements || []), _toConsumableArray(county_requirements || []), _toConsumableArray(city_requirements || [])).length !== 0);
  var eligTextEmpty = isEligTextEmpty(eligibility_text);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('program-description__eligibility', className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames({
      hidden: eligTextEmpty
    })
  }, /*#__PURE__*/React.createElement(ExpandableContainer, {
    collapsedHeight: "70px",
    id: "test-expandable",
    controlled: true,
    isOpen: showMore,
    hideToggle: true,
    showGradient: showLess
  }, /*#__PURE__*/React.createElement("h4", {
    className: "mb-half"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Tl36ae",
    description: "eligibility",
    defaultMessage: "Eligibility"
  })), /*#__PURE__*/React.createElement(DraftEditorField, {
    className: "pb-one",
    hideLabel: true,
    id: "program-eligibility_text",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "Tl36ae",
      description: "eligibility",
      defaultMessage: "Eligibility"
    }),
    readOnly: true,
    value: eligibility_text || ''
  }))), eligTextEmpty && description && showLess ? /*#__PURE__*/React.createElement(ExpandableContainer, {
    collapsedHeight: "70px",
    id: "test-expandable",
    controlled: true,
    isOpen: showMore,
    hideToggle: true,
    showGradient: showLess
  }, /*#__PURE__*/React.createElement("h4", {
    className: "mb-one"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "rT7jXR",
    description: "description",
    defaultMessage: "Description"
  })), /*#__PURE__*/React.createElement(DraftEditorField, {
    className: "mb-two",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "rT7jXR",
      description: "description",
      defaultMessage: "Description"
    }),
    hideLabel: true,
    id: "program-description-text",
    value: description,
    readOnly: true
  })) : null, hasRegionalElig && showMore ? /*#__PURE__*/React.createElement("div", null, eligTextEmpty ? null : /*#__PURE__*/React.createElement(Divider, {
    className: "program-details__divider"
  }), /*#__PURE__*/React.createElement("h4", {
    className: "mb-one"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "jwwDck",
    description: "clients-must-live-text",
    defaultMessage: "Client must live in the following..."
  })), transformedStateRequirements && /*#__PURE__*/React.createElement(LabelTextInline, {
    className: "mb-one",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "XW82Wp",
      description: "states",
      defaultMessage: "States"
    }),
    content: transformedStateRequirements
  }), (county_requirements === null || county_requirements === void 0 ? void 0 : county_requirements.length) > 0 && /*#__PURE__*/React.createElement(LabelTextInline, {
    className: "mb-one",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "mZ2nD1",
      description: "counties",
      defaultMessage: "Counties"
    }),
    content: countyRequirments
  }), (city_requirements === null || city_requirements === void 0 ? void 0 : city_requirements.length) > 0 && /*#__PURE__*/React.createElement(LabelTextInline, {
    className: "mb-one",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "Zonjcr",
      description: "cities",
      defaultMessage: "Cities"
    }),
    content: cityRequirements
  }), (postal_code_requirements === null || postal_code_requirements === void 0 ? void 0 : postal_code_requirements.length) > 0 && /*#__PURE__*/React.createElement(LabelTextInline, {
    className: "mb-one",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "aDv4mN",
      description: "zip-codes",
      defaultMessage: "Zip codes"
    }),
    content: postalCodeRequirements
  })) : null, showMore && /*#__PURE__*/React.createElement("div", null, !eligTextEmpty || hasRegionalElig ? /*#__PURE__*/React.createElement(Divider, {
    className: "program-details__divider"
  }) : null, /*#__PURE__*/React.createElement(LabelTextInline, {
    className: "mb-one",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "zPsx0I",
      description: "populations-restriction",
      defaultMessage: "Populations restricted to"
    }),
    content: population_restrictions
  }), /*#__PURE__*/React.createElement(LabelTextInline, {
    className: "mb-one",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "sUXZue",
      description: "gender-requirements",
      defaultMessage: "Genders restricted to"
    }),
    content: genderRequirements
  }), /*#__PURE__*/React.createElement(LabelTextInline, {
    className: "mb-one",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "xByfh4",
      description: "age-requirements",
      defaultMessage: "Ages restricted to"
    }),
    content: transformedAgeRequirements
  }), /*#__PURE__*/React.createElement(LabelTextInline, {
    className: "mb-one",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "o0u6lY",
      description: "population-catered",
      defaultMessage: "Populations specialized in"
    }),
    content: population_specializations
  }), /*#__PURE__*/React.createElement(LabelTextInline, {
    className: "mb-one",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "XKOAjP",
      description: "age-specialization",
      defaultMessage: "Ages specialized in"
    }),
    content: transformedAgeSpecializations
  }), /*#__PURE__*/React.createElement(LabelTextInline, {
    className: "mb-one",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "RqjsZm",
      description: "languages",
      defaultMessage: "Languages"
    }),
    content: languages
  }), /*#__PURE__*/React.createElement(LabelTextInline, {
    className: "mb-one",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "lpYuHX",
      description: "transportation",
      defaultMessage: "Transportation"
    }),
    content: transportation_options
  }), /*#__PURE__*/React.createElement(LabelTextInline, {
    className: "mb-one",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "J9KLw4",
      description: "accessibility",
      defaultMessage: "Accessibility"
    }),
    content: accessibility_options
  }), /*#__PURE__*/React.createElement(LabelTextInline, {
    className: "mb-one",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "kCUBP8",
      description: "primary-service-delivery",
      defaultMessage: "Primary Method of Service Delivery"
    }),
    content: delivery_options
  }), /*#__PURE__*/React.createElement(LabelTextInline, {
    className: "mb-one",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "MIPeJV",
      description: "payment-options",
      defaultMessage: "Payment options"
    }),
    content: payment_options
  })));
};
ProgramEligibility.propTypes = {
  className: PropTypes.string,
  showMore: PropTypes.bool,
  showLess: PropTypes.bool,
  program: PropTypes.object.isRequired
};
ProgramEligibility.defaultProps = {
  className: '',
  showLess: false,
  showMore: false
};
export default ProgramEligibility;